import type { TemplateResponse } from "types/Template.type";

import { api } from "utils/api";

export const getTemplates = () => api.get<TemplateResponse>("/template");

export const getTemplatePreview = (templateId: string, languageId: string) =>
  api.get<string>(`/template/${templateId}/preview/${languageId}`, undefined, {
    responseType: "blob",
    suppressToast: true,
  });

export const downloadTemplate = (templateId: string) =>
  api.get<Blob>(`/company/settings/template/${templateId}`, undefined, { responseType: "blob" });

export const addCustomTemplate = (data: any) => {
  const formData = new FormData();
  formData.append("file", data.file);

  return api.post("/company/settings/template", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
